import { cn } from '@fe-learner-common';
import { FC } from 'react';

interface SpinnerProps {
  className?: string;
  name?: string;
}

export const Spinner: FC<SpinnerProps> = ({ className, name }) => (
  <svg
    key={name}
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    className={cn('lf:animate-spin', className)}
  >
    <mask id={`${name}-b`} fill="#fff">
      <path d="M20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10ZM4 10a6 6 0 1 0 12 0 6 6 0 0 0-12 0Z" />
    </mask>
    <path
      stroke={`url(#${name}-a)`}
      strokeWidth={8}
      d="M20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10ZM4 10a6 6 0 1 0 12 0 6 6 0 0 0-12 0Z"
      mask={`url(#${name}-b)`}
    />
    <defs>
      <linearGradient
        id={`${name}-a`}
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopOpacity={0} stopColor="currentColor" />
        <stop offset={1} stopColor="currentColor" />
      </linearGradient>
    </defs>
  </svg>
);
